import React from 'react';
import { useFormContext } from 'react-hook-form';
import { useTranslation } from 'react-i18next';

import { FOR_BANK_SECTIONS, FOR_BANK_SUB_SECTIONS } from 'constants/businessToolSections/forBank';

import useCheckSubSectionAccess from 'hooks/useCheckSubSectionAccess';

import { TextInputControl } from 'components/_basic/Form/TextInput';
import { FormHeader } from 'components/_basic/FormHeader/FormHeader';
import { FormSectionCard } from 'components/_basic/FormSectionCard/FormSectionCard';
import { FORM_SECTION_CARD_VARIANT } from 'components/_basic/FormSectionCard/types';

import { concatWithDot } from 'helpers/string';

import { prefix, PRODUCTS_AND_SERVICES_ADVANTAGES_NAMES } from './utils/form';
import { GLOBAL_FIELD_NAMES, globalPrefix } from '../../Global/form';

export const ProductAndServicesAdvantages: React.FC = () => {
  const { t } = useTranslation();
  const { control } = useFormContext();

  const canAccess = useCheckSubSectionAccess(
    FOR_BANK_SECTIONS.PRODUCTS_AND_SERVICES,
    FOR_BANK_SUB_SECTIONS.FOR_BANK_PRODUCTS_AND_SERVICES.ADVANTAGES,
  );

  return (
    <>
      <FormSectionCard variant={FORM_SECTION_CARD_VARIANT.LARGE}>
        <FormHeader
          locked={!canAccess}
          title={t('productsAndServicesForm.title')}
          badgeText={t('productsAndServicesForm.uniqueness.title')}
          section={FOR_BANK_SECTIONS.PRODUCTS_AND_SERVICES}
        />
      </FormSectionCard>
      <FormSectionCard
        disabled={!canAccess}
        title={t('productsAndServicesForm.uniqueness.specifyUniqueness')}
        aiFieldName={concatWithDot(globalPrefix, GLOBAL_FIELD_NAMES.COMPETITIVE_ADVANTAGE)}
      >
        {/* 3.2.1 */}
        <TextInputControl
          multiline
          control={control}
          id="productsAndServicesForm.uniqueness"
          name={concatWithDot(globalPrefix, GLOBAL_FIELD_NAMES.COMPETITIVE_ADVANTAGE)}
          minRows={4}
          disabled={!canAccess}
          maxLength={1500}
        />
      </FormSectionCard>
      <FormSectionCard
        disabled={!canAccess}
        title={t('productsAndServicesForm.uniqueness.whatValueToTheCustomer')}
        aiFieldName={concatWithDot(prefix, PRODUCTS_AND_SERVICES_ADVANTAGES_NAMES.PRODUCT_VALUE)}
      >
        {/* 3.2.3 */}
        <TextInputControl
          multiline
          control={control}
          id="productsAndServicesForm.productValue"
          name={concatWithDot(prefix, PRODUCTS_AND_SERVICES_ADVANTAGES_NAMES.PRODUCT_VALUE)}
          minRows={4}
          disabled={!canAccess}
          maxLength={1500}
        />
      </FormSectionCard>
    </>
  );
};
